var _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "wave",
    style: {
      transform: "rotate(0deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 470",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(35.76, 200.713, 83.948, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(39.61, 125.516, 157.454, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,282L17.1,297.7C34.3,313,69,345,103,360.3C137.1,376,171,376,206,321.2C240,266,274,157,309,133.2C342.9,110,377,172,411,180.2C445.7,188,480,141,514,125.3C548.6,110,583,125,617,156.7C651.4,188,686,235,720,235C754.3,235,789,188,823,141C857.1,94,891,47,926,23.5C960,0,994,0,1029,54.8C1062.9,110,1097,219,1131,235C1165.7,251,1200,172,1234,156.7C1268.6,141,1303,188,1337,219.3C1371.4,251,1406,266,1440,274.2C1474.3,282,1509,282,1543,282C1577.1,282,1611,282,1646,305.5C1680,329,1714,376,1749,360.3C1782.9,345,1817,266,1851,258.5C1885.7,251,1920,313,1954,321.2C1988.6,329,2023,282,2057,242.8C2091.4,204,2126,172,2160,203.7C2194.3,235,2229,329,2263,336.8C2297.1,345,2331,266,2366,219.3C2400,172,2434,157,2451,148.8L2468.6,141L2468.6,470L2451.4,470C2434.3,470,2400,470,2366,470C2331.4,470,2297,470,2263,470C2228.6,470,2194,470,2160,470C2125.7,470,2091,470,2057,470C2022.9,470,1989,470,1954,470C1920,470,1886,470,1851,470C1817.1,470,1783,470,1749,470C1714.3,470,1680,470,1646,470C1611.4,470,1577,470,1543,470C1508.6,470,1474,470,1440,470C1405.7,470,1371,470,1337,470C1302.9,470,1269,470,1234,470C1200,470,1166,470,1131,470C1097.1,470,1063,470,1029,470C994.3,470,960,470,926,470C891.4,470,857,470,823,470C788.6,470,754,470,720,470C685.7,470,651,470,617,470C582.9,470,549,470,514,470C480,470,446,470,411,470C377.1,470,343,470,309,470C274.3,470,240,470,206,470C171.4,470,137,470,103,470C68.6,470,34,470,17,470L0,470Z"
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-1",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(39, 9, 187, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 2, 51, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 50px)",
      opacity: 0.9
    },
    fill: "url(#sw-gradient-1)",
    d: "M0,423L17.1,368.2C34.3,313,69,204,103,188C137.1,172,171,251,206,266.3C240,282,274,235,309,242.8C342.9,251,377,313,411,344.7C445.7,376,480,376,514,313.3C548.6,251,583,125,617,70.5C651.4,16,686,31,720,31.3C754.3,31,789,16,823,15.7C857.1,16,891,31,926,78.3C960,125,994,204,1029,266.3C1062.9,329,1097,376,1131,383.8C1165.7,392,1200,360,1234,352.5C1268.6,345,1303,360,1337,344.7C1371.4,329,1406,282,1440,235C1474.3,188,1509,141,1543,164.5C1577.1,188,1611,282,1646,329C1680,376,1714,376,1749,344.7C1782.9,313,1817,251,1851,203.7C1885.7,157,1920,125,1954,156.7C1988.6,188,2023,282,2057,305.5C2091.4,329,2126,282,2160,227.2C2194.3,172,2229,110,2263,101.8C2297.1,94,2331,141,2366,156.7C2400,172,2434,157,2451,148.8L2468.6,141L2468.6,470L2451.4,470C2434.3,470,2400,470,2366,470C2331.4,470,2297,470,2263,470C2228.6,470,2194,470,2160,470C2125.7,470,2091,470,2057,470C2022.9,470,1989,470,1954,470C1920,470,1886,470,1851,470C1817.1,470,1783,470,1749,470C1714.3,470,1680,470,1646,470C1611.4,470,1577,470,1543,470C1508.6,470,1474,470,1440,470C1405.7,470,1371,470,1337,470C1302.9,470,1269,470,1234,470C1200,470,1166,470,1131,470C1097.1,470,1063,470,1029,470C994.3,470,960,470,926,470C891.4,470,857,470,823,470C788.6,470,754,470,720,470C685.7,470,651,470,617,470C582.9,470,549,470,514,470C480,470,446,470,411,470C377.1,470,343,470,309,470C274.3,470,240,470,206,470C171.4,470,137,470,103,470C68.6,470,34,470,17,470L0,470Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave3);
export default __webpack_public_path__ + "static/media/wave3.9756f7a4ee1cf6f3f952876af8d64811.svg";
export { ForwardRef as ReactComponent };